import { AnnoUiRegionItem } from 'utils/cfUiItems/annotations';
import { TIAnnotationMST } from 'modules/Annotations/store/annotation';

export enum ZoomType {
  Zoom_In = 'Zoom_IN',
  Zoom_Out = 'Zoom_Out',
}

// For Canvas Region Annotation, we use AnnotationMST to keep the structure same
export type CanvasRegionAnnotation = AnnoUiRegionItem<TIAnnotationMST>;

export interface CanvasRegionBaseConfig {
  key: string;
  text?: string;
  concept?: CF.API.Concept;
}

export interface RectConfig extends CanvasRegionBaseConfig {
  x: number;
  y: number;
  width: number;
  height: number;
  color: string;
}

export interface PolygonConfig extends CanvasRegionBaseConfig {
  points: [col: number, row: number][];
  stroke: string;
}

export interface MaskConfig extends CanvasRegionBaseConfig {
  base64: string;
  color: string;
}
